export default "__VITE_ASSET__tzmx3ODj__"